import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { School } from 'bookraw/shared/models/school.model';
import { environment } from 'env/environment';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaginationData } from 'bookraw/shared/models/pagination-data';

@Injectable()
export class SchoolsService extends ListService<School> {

  url: string = '/api/admin/schools';

  promote(schoolId: number, data: { userIds: number[] }) {
    return this.http.put(environment.baseURL + this.url + '/' + schoolId + '/promote', data);
  }

  demote(schoolId: number, data: { userIds: number[] }) {
    return this.http.put(environment.baseURL + this.url + '/' + schoolId + '/demote', data);
  }

  blacklistBulk(schoolIds: number[], bookIds: number[]) {
    return this.http.post(environment.baseURL + this.url + '/blacklistBulk', { schoolIds, bookIds });
  }

  export(schoolIds: string) {
    const headers = new HttpHeaders().set('Accept', 'application/vnd.ms-excel');
    return this.http.get(environment.baseURL + this.url + '/export', {
      headers, observe: 'response', params: { schoolIds }, responseType: 'blob'
    });
  }

  classroomIntegrate(schoolId: number, data: { classroomDomain: string }) {
    return this.http.put(environment.baseURL + this.url + '/' + schoolId + '/classroomIntegrate', data);
  }

  getForSelect(text: string): Observable<PaginationData<School>> {
    this.setQueryParam('basic', '1');
    this.setQueryParam('filters[name]', text);
    return this.get();
  }

}
